import cn from 'classnames';
import dibsCss from 'dibs-css';
import { FormattedMessage } from 'dibs-react-intl';
import ChevronDown from 'dibs-icons/exports/ChevronDown';
import ChevronUp from 'dibs-icons/exports/ChevronUp';

export const readMoreButton = (
    <span
        className={cn(
            dibsCss.sassyFontBodySmallHeavy,
            dibsCss.inlineFlex,
            dibsCss.itemsCenter,
            dibsCss.gapXxsmall
        )}
    >
        <FormattedMessage id="SellerReviews.readMore" defaultMessage="Read More" />
        <ChevronDown variation="20" />
    </span>
);

export const readLessButton = (
    <span
        className={cn(
            dibsCss.sassyFontBodySmallHeavy,
            dibsCss.inlineFlex,
            dibsCss.itemsCenter,
            dibsCss.gapXxsmall
        )}
    >
        <FormattedMessage id="SellerReviews.readLess" defaultMessage="Read Less" />
        <ChevronUp variation="20" />
    </span>
);
